import { freightDeliveryAccessorialPresetIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const deleteFreightDeliveryAccessorialPreset = {
  name: "deleteFreightDeliveryAccessorialPreset" as const,
  input: z.object({ id: freightDeliveryAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
